import "../styles/FormCode.scss";
import {useTranslation} from "react-i18next";
import {useCode} from "../hooks";
import {ARTIST, Artist} from "src/utils/artist.utils";
import {useNavigate} from "react-router-dom";
import {path} from "src/router/path";
import CharacterWithBubble from "../../../components/CharacterWithBubble/CharacterWithBubble";
import SessionTimer from "src/services/session/components/SessionTimer";
import {useEffect} from "react";

type FormCodeProps = {
  artist: Artist;
  onExpire: () => void;
};

const FormCode = ({artist, onExpire}: FormCodeProps) => {
  const {t} = useTranslation("common");

  const navigate = useNavigate();

  const {
    code,
    error,
    ERROR_MESSAGE,
    handleCodeChange,
    handleDelete,
    handleSubmit,
  } = useCode(artist);

  const handleSubmitCode = async () => {
    try {
      const response = await handleSubmit();
      if (response && response.success) {
        navigate(path.character(artist));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (error === ERROR_MESSAGE.EXPIRED) {
      navigate(path.expired(artist));
    }
  }, [error]);

  return (
    <>
      <div className="form-code">
        <h1 className="form-code-title">{t("enterCode.title")}</h1>

        <div className="form-code-content">
          <div className="form-code-character-wrapper">
            <CharacterWithBubble
              content={t("enterCode.notice")}
              artist={artist}
              character={artist === ARTIST.aespa ? "karangi" : "rizuko"}
            />
          </div>
          <div className="form-code-input-wrapper">
            <div className="form-code-input-container">
              <input
                type="text"
                className="form-code-input-field"
                placeholder={t("enterCode.placeholder")}
                value={code}
                onChange={handleCodeChange}
              />
              {code && (
                <button
                  className="form-code-delete-button"
                  onClick={handleDelete}
                  type="button"
                >
                  <div
                    style={{
                      marginBottom: 2,
                    }}
                  >
                    ×
                  </div>
                </button>
              )}
            </div>
            <p className="form-code-error-message">
              {error === ERROR_MESSAGE.INVALID &&
                t("enterCode.error.invalidCode")}
            </p>
          </div>
          <SessionTimer onExpire={onExpire} />
        </div>

        <button
          type="button"
          className={`form-code-submit-button ${artist}`}
          onClick={handleSubmitCode}
        >
          {t("enterCode.verifyButton")}
        </button>
      </div>
    </>
  );
};

export default FormCode;
